import { render, staticRenderFns } from "./4_hearingAid.vue?vue&type=template&id=14bcf49b&scoped=true&"
import script from "./4_hearingAid.vue?vue&type=script&lang=js&"
export * from "./4_hearingAid.vue?vue&type=script&lang=js&"
import style0 from "./4_hearingAid.vue?vue&type=style&index=0&id=14bcf49b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bcf49b",
  null
  
)

export default component.exports